<template>
  <v-card outlined>
    <v-card-title>
      {{ $t("requirementResultInfo.title") }}
    </v-card-title>

    <v-simple-table>
      <template #default>
        <tbody>
          <tr v-if="!requirement.result.applicable">
            <td>
              {{ $t("requirementResultInfo.applicable.title") }}
            </td>
            <td>
              {{ $t("requirementResultInfo.applicable.notApplicable") }}
            </td>
          </tr>

          <template v-else>
            <tr v-if="requirement.result.result">
              <td>
                {{ $t("requirementResultInfo.result.title") }}
              </td>
              <td>
                {{ requirement.result.result }}
              </td>
            </tr>

            <tr v-if="requirement.result.points === 0 || requirement.result.points">
              <td>
                {{ $t("requirementResultInfo.points.title") }}
              </td>
              <td>
                {{ requirement.result.points }}
              </td>
            </tr>
          </template>

          <tr>
            <td>
              {{ $t("requirementResultInfo.description.title") }}
            </td>

            <td>
              <Markdown :value="requirement.result.description" />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  props: {
    requirement: {
      type: Object,
      required: true,
    },
  },
};
</script>
